<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Database Testing</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Database Testing</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>What is Database Testing?</h3>
                    <p>Database Testing is a type of software testing that checks the schema, tables, triggers, etc. of
                        the Database under
                        test. It also checks data integrity and consistency. It may involve creating complex queries to
                        load/stress test the
                        Database and check its responsiveness.
                    </p>
                    <h3>Why Database Testing is Important?</h3>
                    <p>Database Testing is important in software testing because it ensures data values and information
                        received and stored
                        into database are valid or not. Database testing helps to save data loss, saves aborted
                        transaction data and no
                        unauthorized access to the information. Database is important for any software application hence
                        testers must have good
                        knowledge of SQL for database testing.

                        The GUI is usually given the most emphasis by the test and development team members since the
                        Graphical User Interface
                        happens to be the most visible part of the application. However, what is also important is to
                        validate the information
                        that is the heart of the application, aka DATABASE.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> Structural Testing</li>
                                    <li><i class="flaticon-check"></i> Functional Testing</li>
                                    <li><i class="flaticon-check"></i> Non-functional Testing</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Unit Test Cases</a></li>
                        <li><a routerLink="/technology-expertise">Bug Reports</a></li>
                        <li><a routerLink="/technology-expertise">Selenium</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">JMeter</a></li>
                        <li><a routerLink="/technology-expertise">Jira</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/ui-testing-services">
                            <img src="assets/img/services/services-11.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/ui-testing-services">UI Testing</a>
                        </h3>
                        <span>Frontend Test</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/api-testing-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/api-testing-services">API Testing</a>
                        </h3>
                        <span>Using Tool</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/automation-testing-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/automation-testing-services">Automation Testing</a>
                        </h3>
                        <span>Using Tools</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->